import { GLAdjustment } from './glAdjustment.model';

export class PostedRemittanceGLAdjustment {
  constructor(
    public Client_ClientId: string,
    public PaymentDetail_Remittance_RemittanceId: number,
    public GLAdjustments: GLAdjustment[],
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/postedRemittanceGLAdjustment.model.ts